import React from 'react'

const Cost = ({positive, amount}) => (
    <span className="toolbar__menu-button-cost">
        {positive ? '+' : '-'}
        <img
            alt="resources"
            className="toolbar__menu-button-cost-icon"
            src={`${process.env.PUBLIC_URL}/img/resources-green.png`}
        />
        {amount}
    </span>
)

export default Cost
